const WORKER_URL = import.meta.env.VITE_WORKER_URL ?? "http://localhost:8787";

async function request(path, { signal } = {}) {
	const resp = await fetch(`${WORKER_URL}${path}`, { signal });
	if (!resp.ok) {
		let message = `Request failed: ${resp.status}`;
		try {
			const body = await resp.json();
			if (body?.error) message = body.error;
		} catch {
			// non-JSON body, keep default message
		}
		const err = new Error(message);
		err.status = resp.status;
		throw err;
	}
	return resp.json();
}

// Anime structure is TVmaze-backed (search / show / season+episode catalog), so the
// shapes returned here are identical to api/tv.js (keyed by tvmaze_id).
export function searchAnime(query, { limit = 20, signal } = {}) {
	const params = new URLSearchParams({ q: query, limit: String(limit) });
	return request(`/anime/search?${params}`, { signal });
}

export function getAnime(tvmazeId, { signal } = {}) {
	return request(`/anime/${tvmazeId}`, { signal });
}

// The full season/episode catalog in one call: { tvmaze_id, seasons, episodes }.
export function getAnimeEpisodes(tvmazeId, { signal } = {}) {
	return request(`/anime/${tvmazeId}/episodes`, { signal });
}

// Best-effort MAL genre enrichment by title (+ optional year). Returns
// { mal_id, matched_title, genres, themes, demographics, studios, mal_source } —
// all empty/null when there's no confident match.
export function enrichAnime(title, year, { signal } = {}) {
	const params = new URLSearchParams({ title });
	if (year) params.set("year", String(year));
	return request(`/anime/enrich?${params}`, { signal });
}
